import MultiSubmit from './MultiSubmit';

export type { MultiSubmitRow } from './types';
export default MultiSubmit;
